import { Card, CardContent, CardHeader, Stack, Table, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Loading from "../components/Loading";
import { useGetOrderReportQuery } from "../features/reports/reportsSlice";

const PerStoreOverdue = ({name, store}) => {
    return <Table>
        <TableHead>
            <TableRow>
                <TableCell>{name}</TableCell>
                <TableCell>Total: {store.total}</TableCell>
            </TableRow>
        </TableHead>
        {store.orders.map((o) => {
            
        })}
    </Table>;
}

const OverdueOrdersReport = () => {
    const reportQuery = useGetOrderReportQuery("overdue")
    if(!reportQuery.data || reportQuery.isLoading || reportQuery.isError) return <Loading />;
    console.log(reportQuery.data);
    const data = reportQuery.data;
    return <Card sx={{marginTop: 3}}>
        <CardHeader title="Overdue orders report" />
        <CardContent>
            <Stack direction={"column"}>
            <Typography variant="body">Total: {data.totals.total} open orders.</Typography>
            <Typography variant="body">{data.totals.total_unpacked} processed but unpacked orders older than {data.thresholds.unpacked_dayspan} business days.</Typography>
            <Typography variant="body">{data.totals.total_unprocessed} unprocessed orders older than {data.thresholds.dayspan} business days.</Typography>
            <Typography variant="body">{data.totals.late_remakes} remakes older than 5 business days.</Typography>
            {Object.keys(data.per_store).map((key, idx) => <PerStoreOverdue key={idx} name={key} store={key} />)}
            </Stack>
        </CardContent>
    </Card>;
}

export { OverdueOrdersReport };